/**
 * Base widget event names as constants
 * Can be extended by specific widgets
 */
export const BASE_WIDGET_EVENTS = {
    MOUNTED: 'mounted',
    READY: 'ready',
    SHOW: 'show',
    HIDE: 'hide',
    UNMOUNTED: 'unmounted',
    RESIZE: 'resize',
    FULLSCREEN_ENTERED: 'fullscreenEntered',
    FULLSCREEN_EXITED: 'fullscreenExited',
    COLLAPSED: 'collapsed',
    EXPANDED: 'expanded',
    CONTEXT_UPDATED: 'contextUpdated',
    ERROR: 'error',
};
//# sourceMappingURL=WidgetEvents.js.map